const HeroBackground = () => (
  <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden z-0">
    <div className="blob-a absolute -left-[10%] -top-[25%] h-[55vmax] w-[55vmax] rounded-full bg-brand-blue/30 blur-[120px]" />
    <div className="blob-b absolute -right-[15%] top-[10%] h-[45vmax] w-[45vmax] rounded-full bg-brand-blue/20 blur-[120px]" />
    <div className="blob-c absolute bottom-[-30%] left-[25%] h-[40vmax] w-[40vmax] rounded-full bg-brand-blue/25 blur-[120px]" />

    <div
      className="absolute inset-0 opacity-60 [mask-image:radial-gradient(ellipse_at_center,black,transparent_75%)]"
      style={{
        backgroundImage:
          'linear-gradient(rgba(98,198,244,.15) 1px, transparent 1px), linear-gradient(90deg, rgba(98,198,244,.15) 1px, transparent 1px)',
        backgroundSize: '64px 64px',
      }}
    />

    {/* sfumatura verso il nero in basso */}
    <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-brand-black" />
  </div>
);

export default HeroBackground;